var _defs, _path, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCushion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.37,4.72c.17,0,.35,0,.53,.01,9.54,.29,28.38,2.07,38.54,11.17,10.53,9.43,10.24,31.41,10.53,39.09,.04,3.14-.63,29.05-10.59,38.82-9.96,9.77-23.88,11.22-38.19,10.83-14.31-.39-34.81-.77-41.38-10.93s-9.99-15.18-9.96-39.74c.03-22.92,3.87-32,10.83-38.87S42.56,4.38,55.37,4.72Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "15.68 15.12 31.34 17.63 54.91 4.7 78.53 16.95 94.44 15.91 92.93 31.46 104.94 54.17 92.55 78.64 93.79 94.39 78.04 92.27 56.19 104.65 31.34 92.37 14.81 93.72 17.42 77.67 4.85 53.98 17.03 31.94 15.68 15.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "17.03 31.94 32.12 31.94 31.34 17.63 54.91 28.65 78.53 16.95 78.14 31.94 81.33 54.27 92.55 78.64 78.24 77.67 78.04 92.27 55.37 81.35 31.34 92.37 32.12 77.57 17.34 78.16 28.64 54.66 17.03 31.94"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "32.12 31.94 28.64 54.66 32.12 77.57 55.76 81.53 78.24 77.67 81.33 54.27 92.93 31.46 78.22 32.47 54.91 28.65 32.12 31.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCushion);
export default __webpack_public_path__ + "static/media/cushion.ca2b5bc7c8a49652bb5a013c42f22a4f.svg";
export { ForwardRef as ReactComponent };